import React, { useEffect } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import { withTranslation } from 'react-i18next';
import Store from 'store';
import { ContentsWrap } from '../components/Common';
import { BasketModal } from '../components/designs/DesignPage';
import store from '../store';

import { BestDesign } from '../components/main/bestDesign';
import { CategoryView } from '../components/main/categoryView';
import { HomeBanner1 } from '../components/main/homeBanner1';
import { HomeBanner2 } from '../components/main/homeBanner2';
import { HomeBanner3 } from '../components/main/homeBanner3';
import { NewDesign } from '../components/main/newDesign';
import { Notice } from '../components/main/notice';
import { Partner } from '../components/main/partner';
import { RecommendDesign } from '../components/main/recommendDesign';
import { Search } from '../components/main/search';
import { StyleView } from '../components/main/styleView';
import { TopDesigner } from '../components/main/topDesigner';
import { TrendBanner } from '../components/main/trendBanner';
import { HomePageProvider, useHomePageContext } from '../context/HomePageContext';

const HomePageContent = ({ history }) => {
  const { state, actions, responsiveConfig } = useHomePageContext();

  useEffect(() => {
    const accessToken = Store.get('accessToken');
    const isEmailVerified = store.getState().is_email_verified;

    if (accessToken !== undefined && !isEmailVerified) {
      return history.push('/auth/email/register');
    }
  }, []);

  const { interest_list, category } = store.getState();

  return (
    <>
      <HomeBanner1 />
      <ContentsWrap>
        <Search keywordList={state.keywordList} />
        <NewDesign interest_list={interest_list} />
        <StyleView />
        <TrendBanner />
        <CategoryView ctgresponsive={responsiveConfig.category} category={category} />
        <TopDesigner mainresponsive={responsiveConfig.main} setStateAsync={actions.setUI} />
        <RecommendDesign interest_list={interest_list} ShowBasketModal={actions.showBasketModal} />
        <HomeBanner2 />
        <BestDesign
          interest_list={interest_list}
          ShowBasketModal={actions.showBasketModal}
          setStateAsync={actions.setUI}
        />
        <HomeBanner3 homeBannerListKo={state.data.homeBannerListKo} homeBannerListEn={state.data.homeBannerListEn} />
        <Partner main_title_6_ko={state.data.main_title_6_ko} main_title_6_en={state.data.main_title_6_en} />
        <Notice />
      </ContentsWrap>

      <BasketModal show={state.ui.showbasket} onClose={actions.closeBasketModal} onConfirm={actions.goBasket} />
    </>
  );
};

const HomePage = (props) => (
  <HomePageProvider>
    <HomePageContent {...props} />
  </HomePageProvider>
);

export default withTranslation()(HomePage);
